import Container from 'react-bootstrap/Container';
import { determineTenant } from '../utils/tenants';
import { getUserTenants } from '../utils/Permissions';
import { TermsAndConditionsContentInvestCEO } from '../docs/terms/investceo/latest';
import { TermsAndConditionsContentALM } from '../docs/terms/alm/latest';
import { TermsAndConditionsContentSmithfield } from '../docs/terms/smithfield/latest';
import { PrivacyPolicyContentALM } from '../docs/privacy/alm/latest';
import { PrivacyPolicyContentSmithfield } from '../docs/privacy/smithfield/latest';

const TENANT_TERMS = {
    investceo: { label: 'InvestCEO', component: TermsAndConditionsContentInvestCEO },
    smithfield: { label: 'Smithfield', component: TermsAndConditionsContentSmithfield },
    alm: { label: 'ALM Trading', component: TermsAndConditionsContentALM },
};

const TENANT_PRIVACY = {
    smithfield: { label: 'Smithfield', component: PrivacyPolicyContentSmithfield },
    // InvestCEO and ALM users are covered by ALM's licensor-agnostic privacy policy.
    investceo: { label: 'InvestCEO', component: PrivacyPolicyContentALM },
    alm: { label: 'ALM Trading', component: PrivacyPolicyContentALM },
};

export const TermsPage = () => {
    const userTenants = getUserTenants();
    // If logged in with tenants, show all their tenant T&Cs; otherwise fall back to URL-based tenant
    const tenants = userTenants.length > 0 ? userTenants : [determineTenant()];

    return (
        <Container className="py-4" style={{ maxWidth: '900px' }}>
            {tenants.map((tenant) => {
                const entry = TENANT_TERMS[tenant] || TENANT_TERMS.alm;
                const TermsContent = entry.component;
                return (
                    <div key={tenant} className={tenants.length > 1 ? 'mb-5 pb-4 border-bottom' : ''}>
                        {tenants.length > 1 && (
                            <h4 className="text-muted mb-3">{entry.label}</h4>
                        )}
                        <TermsContent />
                    </div>
                );
            })}
        </Container>
    );
};

export const PrivacyPage = () => {
    const userTenants = getUserTenants();
    // If logged in with tenants, show all their tenant privacy policies; otherwise fall back to URL-based tenant
    const tenants = userTenants.length > 0 ? userTenants : [determineTenant()];

    return (
        <Container className="py-4" style={{ maxWidth: '900px' }}>
            {tenants.map((tenant) => {
                const entry = TENANT_PRIVACY[tenant] || TENANT_PRIVACY.alm;
                const PrivacyContent = entry.component;
                return (
                    <div key={tenant} className={tenants.length > 1 ? 'mb-5 pb-4 border-bottom' : ''}>
                        {tenants.length > 1 && (
                            <h4 className="text-muted mb-3">{entry.label}</h4>
                        )}
                        <PrivacyContent />
                    </div>
                );
            })}
        </Container>
    );
};
